import React, { useMemo, useRef, useState } from "react";
import { InstantSearch } from "react-instantsearch";
import algoliasearch from "algoliasearch/lite";
import { Stack } from "@mui/material";
import SearchResult from "./SearchResult";
import Search from "./Search";
import useClickOutside from "../../../helpers/useClickOutside";

const indices = [{ name: `posts`, title: `Posts` }];

const SearchWidget = ({ title }) => {
  const [hasFocus, setFocus] = useState(false);
  const rootRef = useRef();

  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
      ),
    []
  );

  useClickOutside(rootRef, () => setFocus(false));

  return (
    <Stack ref={rootRef}>
      <InstantSearch
        searchClient={searchClient}
        indexName={indices[0].name}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <Search
          onFocus={() => setFocus(true)}
          hasFocus={hasFocus}
          title={title}
        />

        <SearchResult indices={indices} hasFocus={hasFocus} />
      </InstantSearch>
    </Stack>
  );
};

export default SearchWidget;
